import { render, staticRenderFns } from "./collectClassify.vue?vue&type=template&id=264ee58d&scoped=true&"
import script from "./collectClassify.vue?vue&type=script&lang=js&"
export * from "./collectClassify.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./collectClassify.vue?vue&type=style&index=0&id=264ee58d&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "264ee58d",
  "46872e04"
  
)

export default component.exports